'use strict';

intellidealerAppCoreModule.controller('DashboardNewsDetailController', function ($scope, appConfigurationService, $sce) {

  $scope.getImageUrl = function(timestamp, internalNewsItem) {
    return (timestamp ? appConfigurationService.basePath +
      '/rest/news/dealershipNewsImageByTimestamp?timestamp=' + moment(timestamp).valueOf() + '&internalNewsItem=' + internalNewsItem +
            '&width=600&height=400' : '');
  };

  // need to trust values with html to prevent sanitization
  $scope.trustAsHtml = function(html) {
    return $sce.trustAsHtml(html);
  };

});
